import { z } from 'zod/v4';

const CITypeBucketDTO = z.object({
  ci_count: z.number(),
  doc_count: z.number(),
  ci_type_name: z.string(),
});

const CITypeStatusBucketDTO = z.object({
  ci_count: z.number(),
  ci_type_name: z.string(),
  status: z.string(),
});

export const TransformedEnrichmentLogDTO = z.object({
  'transform._id': z.string(),
  _doc_count: z.number(),
  'transform._doc_count': z.number(),
  doc_count: z.number(),
  unique_ci_count: z.number(),
  ci_type_label: z.string(),
  ci_id: z.string(),
  ci_name: z.string(),
  root_task_id: z.string(),
  '@timestamp': z.string(),
  start_time: z.string(),
  end_time: z.string(),
  overall_status: z.string(),
  overall_status_ru: z.string(),
  execution_status: z.string(),
  execution_status_ru: z.string(),
  by_ci_type: z.object({
    buckets: z.array(CITypeBucketDTO),
  }),
  by_ci_type_status: z.object({
    buckets: z.array(CITypeStatusBucketDTO),
  }),
  status: z.object({
    ERROR: z.number(),
    OK: z.number(),
    WARNING: z.number(),
  }),
});

export type TransformedEnrichmentLog = z.infer<
  typeof TransformedEnrichmentLogDTO
>;

export const RawEnrichmentLogDTO = z.object({
  '@version': z.string(),
  event_type: z.string(),
  event_type_ru: z.string(),
  task_id: z.string(),
  ci_id: z.string(),
  ci_name: z.string(),
  msg_vars: z.object({
    status: z.string(),
    message: z.string(),
    task_id: z.string(),
    ci_id: z.string(),
    ci_type_name: z.string(),
    root_task_id: z.string(),
  }),
  ci_type_label: z.string(),
  status: z.string(),
  '@timestamp': z.string(),
  message: z.string(),
  errors: z.object({
    items: z.array(
      z.tuple([z.string(), z.string(), z.string(), z.looseObject({})]),
    ),
  }),
  debug: z.boolean(),
  root_task_id: z.string(),
});

export type RawEnrichmentLog = z.infer<typeof RawEnrichmentLogDTO>;